import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { QuestionOption, QuestionType, RatingType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { IQuestionOptionForm } from './question-form-group.interface';
import { QuestionForm } from './question-form.model';
import { QuestionOptionForm } from './question-option-form.model';

const DEFAULT_RATING_SCALE = 5;

export class QuestionFormRating extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('type').setValue(QuestionType.Rating);
    this.form.get('ratingType').setValue(RatingType.numeric);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.Rating);
    if (question.ratingType === RatingType.descriptive) {
      this.patchOptions(question.options);
    }
  }

  private extendFormGroup(): void {
    this.form.addControl('options', new FormArray<FormGroup<IQuestionOptionForm>>([]));
    this.form.addControl('ratingType', new FormControl<RatingType>(RatingType.numeric));
    this.form.addControl('ratingScale', new FormControl<number>(DEFAULT_RATING_SCALE));
    this.form.addControl('minValueText', new FormControl<string>('Most unlikely'));
    this.form.addControl('maxValueText', new FormControl<string>('Most likely'));
  }

  private patchOptions(options?: QuestionOption[]): void {
    if (!options || options.length === 0) {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
      return;
    }

    options.forEach((option) => {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }
}
